import { makeStyles, MenuItem, Theme } from "@material-ui/core";
import { FilterList } from "@material-ui/icons";
import React, { useMemo }  from "react";
import { FilterMenu, FilterSearch} from "@ofqual/portal-components/components/ResponseFilter";
import { assignableManagersService, expertsService } from "../../services";
import { useSearch, useUrl, useLookup } from "@ofqual/portal-core/core/hooks";
import { Select } from "@ofqual/portal-components/components/Select";
import { ensureParamIsArray } from "@ofqual/portal-core/core/utils/urlHelper";
import { authSelector } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { SearchField } from "@ofqual/portal-components/components/SearchField";

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      "& fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    menuItem: {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  };
});

export const FilterControls: React.FC = () => {
  const classes = useStyles();
  const { token } = useSelector(authSelector);

  const {
    searchParams,
    navigateToNextSearch,
    searchParamsFiltersOnly,
  } = useSearch(useUrl());

  const [
    managerLookups
  ] = useLookup(
    assignableManagersService
  );

  const expertLookupService = useMemo(
    () => ({
      get: (id: string) => expertsService.get(id, { token }),
      search: (params?: QueryParams) => { 
        let processedParams: QueryParams = {};
        if (!!params) {
          processedParams = { 
            ...params,
            approvedOnly: true,
            search: params.query
          };
        }
        
        return expertsService.search(processedParams, { token })
      }
    }),
    [token]
  );

  return (
    <>
      <FilterSearch
        title="Search..."
        value={searchParams.search}
        onChange={(value) =>
          navigateToNextSearch({
            search: value,
          })
        }
        dataTest={"search"}
      />
      &nbsp;&nbsp;
      <FilterMenu
        Icon={FilterList}
        title="Filters"
        dataTest="filter"
        search={{ searchParamsFiltersOnly, navigateToNextSearch }}
      >
        {(workingParams, dirtyParams, addParam) => (
          <form>
           
           <MenuItem className={classes.menuItem}>
                  <Select
                    className={
                      dirtyParams.includes("assignedManagerUPN")
                        ? classes.root
                        : undefined
                    }
                    label="Assigned Manager"
                    data-test="assigned-manager-upn"
                    selectVariant="multiple"
                    value={ensureParamIsArray(workingParams.assignedManagerUPN)}
                    onChange={(e: any) =>
                      addParam("assignedManagerUPN", e.target.value)
                    }
                  >
                    {managerLookups}
                  </Select>
          </MenuItem>

           <MenuItem className={classes.menuItem}>
              <Select
                className={
                  dirtyParams.includes("CreatedByUser") ? classes.root : undefined
                }
                label="Created By User"
                data-test="created-by-user-filter"
                value={workingParams.CreatedByUser}
                onChange={(e: any) =>
                  e.target.value && addParam("CreatedByUser", e.target.value)
                }
              >
                {managerLookups}
              </Select>
            </MenuItem>

            <MenuItem className={classes.menuItem}>
              <SearchField
                  searchFieldVariant="multiple"
                  className={
                    dirtyParams.includes("SpecialistName")
                      ? classes.root
                      : undefined
                  }
                  onChange={(e: any) =>
                    addParam("SpecialistName", e.target.value)
                  }
                  value={workingParams.SpecialistName}
                  label="Specialist Name"
                  data-test="assigned-sms-filter"
                  service={expertLookupService}
                />
            </MenuItem>

          </form>
        )}
      </FilterMenu>
    </>
  );
};
